import classNames from 'classnames';
import { SectionTextWithColorProps } from 'eco-design-micro/props/msg/SectionTextProps';
import React from 'react';
import './index.scss';
interface EcoSectionProps extends SectionTextWithColorProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 标题类型
     */
    titleType?: string;
}

/**
 *
 * 通用段落
 */
const EcoSection: React.FC<EcoSectionProps> = ({
    className,

    // 文案-label
    label,
    labelColor,
    // 文案-title
    title,
    titleColor,
    titleType,
    // 文案-subTitle
    subTitle,
    subTitleColor,
    // 文案-desc
    desc,
    descColor,

    // size
    pageSize,
    size,
}) => {
    const prefixCls = `eco-section`;
    const sizeUse = size || pageSize;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-size-${sizeUse}`]: sizeUse,
    });
    // 组件 style
    const compStyle = {
        '--eco-design-color-label': labelColor,
        '--eco-design-color-title': titleColor,
        '--eco-design-color-subTitle': subTitleColor,
        '--eco-design-color-desc': descColor,
    } as React.CSSProperties;

    return (
        <div className={classes} style={compStyle}>
            {label && <p className={`${prefixCls}-label`}>{label}</p>}
            {title && (
                <>
                    {titleType ? React.createElement(titleType, { className: `${prefixCls}-title` }, title) : <h2 className={`${prefixCls}-title`}>{title}</h2>}
                </>
            )}
            {subTitle && <p className={`${prefixCls}-subTitle`}>{subTitle}</p>}
            {desc && <div className={`${prefixCls}-desc`}>{desc}</div>}
        </div>
    );
};

export default EcoSection;
